<template>
  <div>
    <h1>Monitoring BDoubleWin</h1>
    <div id="fiche-cdm-filter-container"></div>
    <div class="table-global">
      <h3>Global :</h3>
      <table class="table table-hover table-striped table-bordered">
        <thead>
          <tr >
            <th>Total Fournisseur</th>
            <th>Total Produits</th>
            <th>Proportion Totale BD</th>
            <th>Proportion Totale HD</th>
            <th>Proportion Totale PDF</th>
            <th>Proportion Totale FH</th>
            <th>Proportion Totale Video</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="aggregate.loaded">
            <td>{{ formatNumberInt(aggregate.TotalSupplier) }}</td>
            <td>{{ formatNumberInt(aggregate.TotalProduit) }}</td>
            <td>{{ formatNbPercent(aggregate.TotalProduitBd / aggregate.TotalProduit) }}</td>
            <td>{{ formatNbPercent(aggregate.TotalProduitHd / aggregate.TotalProduit) }}</td>
            <td>{{ formatNbPercent(aggregate.TotalProduitPdf / aggregate.TotalProduit) }}</td>
            <td>{{ formatNbPercent(aggregate.TotalProduitFh / aggregate.TotalProduit) }}</td>
            <td>{{ formatNbPercent(aggregate.TotalProduitVideo / aggregate.TotalProduit) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-container">
      <div class="d-flex justify-content-between mb-3">
        <h3>Détail par fournisseur :</h3>
        <button class="btn btn-warning" @click="exportExcel">Exporter</button>
      </div>
      <table class="table table-hover table-striped table-bordered">
        <thead>
          <tr>
            <th>Id</th>
            <th>Code Intranet</th>
            <th>Nom</th>
            <th>Date dernière modification</th>
            <th>Nombre produits</th>
            <th>Proportion BD</th>
            <th>Proportion HD</th>
            <th>Proportion PDF</th>
            <th>Proportion FH</th>
            <th>Proportion vidéo</th>
            <th>Nombre vidéo</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="frs of data" :key="frs.Id">
            <td>{{ frs.SupplierId }}</td>
            <td>{{ frs.SupplierCode }}</td>
            <td>{{ frs.SupplierName }}</td>
            <td>{{ formatDate(frs.LastModificationDate) }}</td>
            <td>{{ frs.NbProd }}</td>
            <td>{{ formatNbPercent(frs.NbProd == 0 ? 0 : frs.NbProdBd / frs.NbProd) }}</td>
            <td>{{ formatNbPercent(frs.NbProd == 0 ? 0 : frs.NbProdHd / frs.NbProd) }}</td>
            <td>{{ formatNbPercent(frs.NbProd == 0 ? 0 : frs.NbProdPdf / frs.NbProd) }}</td>
            <td>{{ formatNbPercent(frs.NbProd == 0 ? 0 : frs.NbProdFh / frs.NbProd) }}</td>
            <td>{{ formatNbPercent(frs.NbProd == 0 ? 0 : frs.NbProdVideo / frs.NbProd) }}</td>
            <td>{{ frs.NbProdVideo }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import { monitoringFrs } from "@/utils/bdoublewin";
  import { exportExcel } from "@/utils/exportExcel";

  export default {
    name: "MonitoringBdw",
    components: {  },
    data() {
      return {
        data: [],
        aggregate: { loaded: false }
      }
    },
    mounted() {
      monitoringFrs().then(res => {
        this.data = res.sort((a, b) => (a.SupplierName > b.SupplierName) ? 1 : ((a.SupplierName < b.SupplierName ? -1 : 0)));

        /// On calcule à la volée les données du total
        // Total fournisseurs
        var totalSupplier = this.data.length;

        // Total produits
        var totalProduit = 0;

        // Total BD
        var totalProduitBd = 0;

        // Total HD
        var totalProduitHd = 0;

        // Total PDF
        var totalProduitPdf = 0;

        // Total FH
        var totalProduitFh = 0;

        // Total Video
        var totalProduitVideo = 0;

        // Boucle de remplissage
        this.data.forEach(e => {
          totalProduit += e.NbProd;
          totalProduitBd += e.NbProdBd;
          totalProduitHd += e.NbProdHd;
          totalProduitPdf += e.NbProdPdf;
          totalProduitFh += e.NbProdFh;
          totalProduitVideo += e.NbProdVideo;
        });

        this.aggregate.loaded = true;
        this.aggregate.TotalSupplier = totalSupplier;
        this.aggregate.TotalProduit = totalProduit;
        this.aggregate.TotalProduitBd = totalProduitBd;
        this.aggregate.TotalProduitHd = totalProduitHd;
        this.aggregate.TotalProduitPdf = totalProduitPdf;
        this.aggregate.TotalProduitFh = totalProduitFh;
        this.aggregate.TotalProduitVideo = totalProduitVideo;

      });

    },
    methods: {
      exportExcel() {
        const data = this.data.map(frs => {
          return {
            Id: frs.SupplierId,
            Code: frs.SupplierCode,
            Name: frs.SupplierName,
            LastModifDate: this.formatDate(frs.LastModificationDate),
            NbProd: frs.NbProd,
            PropBD: this.formatNbPercent(frs.NbProd == 0 ? 0 : frs.NbProdBd / frs.NbProd),
            PropHD: this.formatNbPercent(frs.NbProd == 0 ? 0 : frs.NbProdHd / frs.NbProd),
            PropPDF: this.formatNbPercent(frs.NbProd == 0 ? 0 : frs.NbProdPdf / frs.NbProd),
            PropFH: this.formatNbPercent(frs.NbProd == 0 ? 0 : frs.NbProdFh / frs.NbProd),
            PropVideo: this.formatNbPercent(frs.NbProd == 0 ? 0 : frs.NbProdVideo / frs.NbProd),
            NbVideo: frs.NbProdVideo,
          }
        })

        const columns = [
          {label: "Id", field: "Id"},
          {label: "Code Intranet", field: "Code"},
          {label: "Nom", field: "Name"},
          {label: "Dernière date de modification", field: "LastModifDate"},
          {label: "Nombre produits", field: "NbProd"},
          {label: "Proportion BD", field: "PropBD"},
          {label: "Proportion HD", field: "PropHD"},
          {label: "Proportion PDF", field: "PropPDF"},
          {label: "Proportion FH", field: "PropFH"},
          {label: "Proportion Vidéo", field: "PropVideo"},
          {label: "Nombre vidéo", field: "NbVideo"},
        ]

        exportExcel(columns, data);

      },
      formatNbPercent(n) {
        return n.toLocaleString("fr-FR", { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },

      // Custom format date (la classe :D)
      formatDate(n) {
        var d = n.substr(0, 10);
        var h = n.substr(11, 8);
        return d + " " + h;
      },

      formatNumberInt(n) {
        return n.toLocaleString("fr-FR", { style: "decimal", minimumFractionDigits: 0, maximumFractionDigits: 0 });
      }
    }
  }
</script>

<style scoped>
  table {
    background: #FFFFFF;
  }


</style>



// WEBPACK FOOTER //
// src/pages/BDoubleWin/MonitoringBdw.vue